import { EditorEligibilityRule } from './editor-eligibility-rule.model';


export class EditorEligibilityRuleHasStringUserField extends EditorEligibilityRule {
  className = 'HasStringUserField';
  operatorName = 'hasUserField';

  userField: string;
  userFieldValuesString: string;

  constructor(obj?: any) {
    super({
      id: obj?.id ?? null
    });
    this.userField = obj?.userField ?? null;
    this.userFieldValuesString = obj?.userFieldValuesString ?? [];
  }

  static getFromSerializedValues(serializedValues: any) {
    return new this({
      userField: serializedValues.userField,
      userFieldValuesString: serializedValues.userFieldValues.join(', ')
    });
  }

  static getEmptyControlConfig(): { [key: string]: any; } {
    return {
      userField: [{ value: null, disabled: true }],
      userFieldValuesString: [{ value: '', disabled: true }],
    };
  }

  createCopy(): EditorEligibilityRuleHasStringUserField {
    return new EditorEligibilityRuleHasStringUserField({
      id: this.id,
      userField: this.userField,
      userFieldValuesString: this.userFieldValuesString
    });
  }

  getUserFieldName(stringUserFieldNames: { id: string, name: string }[]): string {
    if (this.userField === null) { return ''; }
    return stringUserFieldNames
      .find(stringUserFieldName => stringUserFieldName.id === this.userField)?.name ?? $localize `Not valid`;
  }

  getControlsConfig(): { [key: string]: any; } {
    return {
      userField: [this.userField],
      userFieldValuesString: [this.userFieldValuesString]
    };
  }

  getSerializedValues(): any {
    return {
      userFieldType: 'string',
      userField: this.userField,
      userFieldValues: this.userFieldValuesString.split(',').map(itm => itm.trim()),
    };
  }
}
